import { gql } from '@apollo/client';

export const GET_REGIONS = gql`
  query Regions {
    regions {
      id
      legacyResourceId
      name
      default
    }
    topRegions: regions(scope: TOP_REGIONS) {
      name
      legacyResourceId
    }
    otherRegions: regions(scope: OTHER_REGIONS) {
      name
      legacyResourceId
    }
  }
`;
